// Sentry must be imported first
import './instrument';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App.tsx';
import './index.css';
import './styles/support-portal.css';

// Global error handler - report to Sentry, then prevent UI crash
window.addEventListener('error', (event) => {
  if (event.error) {
    Sentry.captureException(event.error);
  }
  console.error('Global error caught:', event.error);
  event.preventDefault();
  event.stopPropagation();
});

window.addEventListener('unhandledrejection', (event) => {
  Sentry.captureException(event.reason);
  console.error('Unhandled promise rejection:', event.reason);
  event.preventDefault();
  event.stopPropagation();
});

createRoot(document.getElementById("root")!).render(<App />);
